import { BASE_URL } from "../../../Constant";

export const API_SAVE_BUSINESS_SERVICE: string = BASE_URL + '/api/businessService'; 
export const API_LOAD_BY_BUSINESS_SERVICE_FOR_BUSINESS_ID: string = BASE_URL + '/api/businessService/businessId'; 
export const API_BUSINESS_SERVICE_IS_SERVICE_EXIST_FOR_BUSINESS: string = BASE_URL + '/api/businessService/isServiceExistForBusiness';

export const SHOW_ALL_BUSINESS: number = 1;
export const SHOW_WORKING_WITH_US: number = 2;
